import PhotoSwipeLightbox from './photoswipe-lightbox.esm.js';
import PhotoSwipe from './photoswipe.esm.js';

// FEATURED PRODUCTS TAB
class FeaturedProducts extends HTMLElement {
  constructor() {
    super();

    this.tabBtns = this.querySelectorAll('.featured-products__btn');
    this.tabs = this.querySelectorAll('.featured-products__tab');
    this.sliderElems = this.querySelectorAll('.featured-products__tab-slider');

    this.init();
  }

  init() {
    this.initSliders();
    this.initTabs();
  }

  initTabs() {
    this.tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        let index = btn.getAttribute('data-index');
        let activeTab = this.querySelector(`.featured-products__tab[data-index="${index}"]`);

        if (activeTab) {
          this.tabBtns.forEach((button) => {
            button.classList.remove('active');
          });

          this.tabs.forEach((tab) => {
            tab.classList.remove('active');
          });

          btn.classList.add('active');
          activeTab.classList.add('active');
        }
      });
    });
  }

  initSliders() {
    this.sliderElems.forEach((sliderElem) => {
      new Swiper(sliderElem, {
        slidesPerView: 1.25,
        spaceBetween: 24,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          900: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },
        },
      });
    });
  }
}

customElements.define('featured-products', FeaturedProducts);


// PRODUCT CARD CHOOSE OPTIONS

class ProductCardOptions extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('.product-card__variant-selection');
    this.variantsData = JSON.parse(this.querySelector('.product-variants-json').innerHTML);
    this.productCard = this.closest('.product-card-wrapper');
    this.priceElement = this.productCard.querySelector('.price__container');

    this.select.addEventListener('change', () => {
      let id = +this.select.value;
      this.changeVariant(id);
    });
  }

  changeVariant(id) {
    let currentVariant = null;
    this.variantsData.forEach((variant) => {
      if (variant.id == id) {
        currentVariant = variant;
      }
    });

    if (currentVariant) {
      let isAvailable = currentVariant.available;
      let price = currentVariant.price;
      let comparePrice = currentVariant.compare_at_price;
      let img = currentVariant.featured_image;

      this.changePrice(price, comparePrice);
      this.changeImage(img);
      this.checkAvailability(isAvailable);
      this.changeFormId(id);
    }
  }

  changeFormId(id) {
    let input = this.productCard.querySelector('form input[name="id"]');
    if (input) {
      input.value = id;
    }
  }

  checkAvailability(isAvailable) {
    let btn = this.productCard.querySelector('.quick-add__submit');

    if (btn) {
      if (!isAvailable) {
        btn.querySelector('.sold-out-message').classList.remove('hidden');
        btn.querySelector('.add-to-cart-message').classList.add('hidden');
        btn.disabled = true;
      } else {
        btn.querySelector('.sold-out-message').classList.add('hidden');
        btn.querySelector('.add-to-cart-message').classList.remove('hidden');
        btn.disabled = false;
      }
    }
  }

  changeImage(img) {
    if (img) {
      let id = img.id;
      let variantImageElem = this.productCard.querySelector(`.variant-image[data-image-id="${id}"]`);
      if (variantImageElem) {
        this.productCard.querySelectorAll('.card__media img').forEach((img) => {
          img.style.display = 'none';
        });

        variantImageElem.style.display = 'block';
      }
    }
  }

  changePrice(price, comparePrice) {
    price = price / 100;
    price = (price % 1 === 0) ? price.toFixed(0) : price.toFixed(2);
    let priceText = `$${price}`;

    if (comparePrice > price) {
      comparePrice = comparePrice / 100;
      comparePrice = (comparePrice % 1 === 0) ? comparePrice.toFixed(0) : comparePrice.toFixed(2);
      let comparePriceText = `$${comparePrice}`;

      this.priceElement.innerHTML = `
                <div class="price--on-sale">
                    <div class="price__sale">
                        <span><s class="price-item price-item--regular">${comparePriceText}</s></span>
                        <span class="price-item price-item--sale price-item--last">${priceText}</span>
                    </div>
                </div>
            `;

    } else {
      this.priceElement.innerHTML = `
                <div class="price__regular">
                    <span class="price-item price-item--regular">${priceText}</span>
                </div>
            `;
    }
  }

}

customElements.define('product-card-options', ProductCardOptions);


// INFO TAB SLIDERS
class InfoSliders extends HTMLElement {
  constructor() {
    super();

    this.tabBtns = this.querySelectorAll('.tab-sliders__btns-item');
    this.tabs = this.querySelectorAll('.tab-sliders__tab');
    this.sliderElems = this.querySelectorAll('.tab-sliders__tab-slider');

    this.init();
  }

  init() {
    this.initSliders();
    this.initTabs();
  }

  initTabs() {
    this.tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        let index = btn.getAttribute('data-index');
        let activeTab = this.querySelector(`.tab-sliders__tab[data-index="${index}"]`);

        if (activeTab) {
          this.tabBtns.forEach((button) => {
            button.classList.remove('active');
          });

          this.tabs.forEach((tab) => {
            tab.classList.remove('active');
          });

          btn.classList.add('active');
          activeTab.classList.add('active');
        }
      });
    });
  }

  initSliders() {
    this.sliderElems.forEach((sliderElem) => {
      let swiper = new Swiper(sliderElem, {
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 500,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      let navElem = sliderElem.parentNode.querySelector('.slider-custom-navigation');

      navElem.querySelectorAll('.slider-custom-navigation__btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          let index = btn.getAttribute('data-index');
          swiper.slideTo(index);
        });
      });

      swiper.on('slideChange', function () {
        let index = swiper.activeIndex;
        let currentNavElem = navElem.querySelector(`.slider-custom-navigation__btn[data-index="${index}"]`);

        if (currentNavElem) {
          navElem.querySelectorAll(`.slider-custom-navigation__btn`).forEach((elem) => {
            elem.classList.remove('active');
          });

          currentNavElem.classList.add('active');
        }
      });
    });
  }

}

customElements.define('tab-sliders', InfoSliders);


// COMPARE SHOW MORE BTN

let compareShowMoreBtns = document.querySelectorAll('.compare-show-more');

if (compareShowMoreBtns.length) {
  compareShowMoreBtns.forEach((btn) => {
    let table = btn.parentNode.querySelector('.compare__table');
    if (table) {
      if (table.scrollHeight > 812) {
        btn.classList.add('visible');
      }
    }

    btn.addEventListener('click', () => {
      if (table) {
        if (!table.classList.contains('open')) {
          table.classList.add('open');
          btn.textContent = 'Show less';
        } else {
          table.classList.remove('open');
          btn.textContent = 'Show more';
        }
      }
    });
  });
}


// MEGA MENU CUSTOM BUTTONS
let closeMobileMenuBtns = document.querySelectorAll('.menu-drawer__header-close-btn');

if (closeMobileMenuBtns.length) {
  closeMobileMenuBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      let detailsElem = btn.closest('.menu-drawer-container');
      let openedSubMenus = document.querySelectorAll('.menu-drawer__menu details.menu-opening .menu-drawer__close-button');

      if (openedSubMenus.length) {
        openedSubMenus.forEach((elem) => {
          elem.click();
        });
      }

      if (detailsElem) {
        detailsElem.querySelector('summary').click();
      }
    });
  });
}


class SearchWindow extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#search-window__results');
    this.closeBtn = this.querySelector('.search-window__close-btn');
    this.overlay = this.querySelector('.search-window__overlay');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.closeBtn.addEventListener('click', () => {
      this.closeWindow();
    });

    this.overlay.addEventListener('click', () => {
      this.closeWindow();
    });
  }

  openWindow() {
    this.classList.add('open');
    setTimeout(() => {
      this.querySelector('.search-window__window').classList.add('drawer-animation');
    }, 1);

    // this.input.focus();
  }

  closeWindow() {
    this.querySelector('.search-window__window').classList.remove('drawer-animation');

    setTimeout(() => {
      this.classList.remove('open');
    }, 300);
  }

  onChange() {
    const searchQuery = this.input.value
      .trim()
      .split(' ')
      .filter(item => item.length > 2)
      .join('&q=');

    if (!searchQuery.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchQuery);
  }

  getSearchResults(searchQuery) {
    fetch(`/search/suggest?q=${searchQuery}&resources[type]=product,article&resources[limit_scope]=each&section_id=predictive-search-results`,
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search-results')
          .innerHTML;

        this.predictiveSearchResults.innerHTML = resultsMarkup;

        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('search-window', SearchWindow);


let openSearchWindowBtn = document.querySelector('[data-open-search-window]');
let searchWindow = document.querySelector('search-window');

if (openSearchWindowBtn && searchWindow) {
  openSearchWindowBtn.addEventListener('click', () => {
    searchWindow.openWindow();
  });
}


// Design Features Section
class DesignFeatures extends HTMLElement {
  constructor() {
    super();

    this.tabBtns = this.querySelectorAll('.design-features__btns-item');
    this.tabs = this.querySelectorAll('.design-features__tab');
    this.imageContentElem = this.querySelectorAll('.image-content-elem');

    this.init();
  }

  init() {
    this.initTabs();
    this.initImageContentElem();
  }

  initImageContentElem() {
    this.imageContentElem.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('open')) {
          btn.classList.remove('open');
        } else {
          this.imageContentElem.forEach((elem) => {
            elem.classList.remove('open');
          });
          btn.classList.add('open');
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (!e.target.classList.contains('image-content-elem') && !e.target.closest('.image-content-elem')) {
        this.imageContentElem.forEach((elem) => {
          elem.classList.remove('open');
        });
      }
    });
  }

  initTabs() {
    this.tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        let index = btn.getAttribute('data-index');
        let activeTab = this.querySelector(`.design-features__tab[data-index="${index}"]`);

        if (activeTab) {
          this.tabBtns.forEach((button) => {
            button.classList.remove('active');
          });

          this.tabs.forEach((tab) => {
            tab.classList.remove('active');
          });

          btn.classList.add('active');
          activeTab.classList.add('active');
        }
      });
    });
  }
}

customElements.define('design-features', DesignFeatures);


// PRODUCT SLIDER
class ProductSlider extends HTMLElement {
  constructor() {
    super();

    this.sliderElem = this.querySelector('.swiper');
    this.thumbnails = this.querySelectorAll('.product-slider__thumbnails-item');
    this.swiper = null;

    this.init();
  }

  init() {
    this.initSlider();
    this.initLightbox();
  }

  initLightbox() {


    const lightbox = new PhotoSwipeLightbox({
      gallery: '.product-slider .swiper-wrapper',
      children: 'a',
      pswpModule: PhotoSwipe,
      padding: {top: 64, bottom: 64, left: 0, right: 0},
      arrowKeys: true,
    });
    lightbox.init();
  }

  initSlider() {
    this.swiper = new Swiper(this.sliderElem, {
      slidesPerView: 1.18,
      spaceBetween: 14,
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        750: {
          slidesPerView: 1,
          spaceBetween: 24,
          centeredSlides: false,
        },
      },
    });


    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        let index = +thumbnail.getAttribute('data-index');

        this.swiper.slideTo(index);
      });
    });


    this.swiper.on('slideChange', () => {
      let index = +this.swiper.activeIndex;

      this.thumbnails.forEach((thumbnail) => {
        thumbnail.classList.remove('active');
      });

      this.thumbnails[index].classList.add('active');
    });
  }

  slideTo(index) {
    this.swiper.slideTo(index);
  }

}

customElements.define('product-slider', ProductSlider);


// PRODUCT TABS

// INFO TAB SLIDERS
class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.tabBtns = this.querySelectorAll('.product-tabs__btns-item');
    this.tabs = this.querySelectorAll('.product__tabs-item');
    this.video = this.querySelector('.product__video-description video');

    this.init();
  }

  init() {
    this.initTabs();

    if (this.video) {
      this.initVideo();
    }
  }

  initVideo() {
    let videoPlayBtn = this.video.parentNode.querySelector('.product__video-description-overlay');

    if (videoPlayBtn) {
      videoPlayBtn.addEventListener('click', () => {
        videoPlayBtn.style.display = 'none';
        this.video.play();
      });
    }
  }

  initTabs() {
    this.tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        let index = btn.getAttribute('data-index');
        let activeTab = this.querySelector(`.product__tabs-item[data-index="${index}"]`);

        if (activeTab) {
          this.tabBtns.forEach((button) => {
            button.classList.remove('active');
          });

          this.tabs.forEach((tab) => {
            tab.classList.remove('opacity-transition-1');
            tab.classList.add('opacity-transition-0');
            tab.classList.remove('active');
          });

          btn.classList.add('active');
          activeTab.classList.add('active');
          setTimeout(() => {
            activeTab.classList.add('opacity-transition-1');
          }, 100);
        }
      });
    });
  }
}

customElements.define('product-tabs', ProductTabs);


// COLLECTION LIST PAGE - GRID COLUMNS BUTTON

class CollectionsColumnsOnMobile extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('button');
    const productGrid = document.querySelector('.shop-by-categories__wrapper');

    buttons.forEach(btn => {
      btn.addEventListener('click', (event) => {
        if (btn.id === 'two-columns') {
          productGrid?.classList.add('two-per-row');
        } else if (btn.id === 'one-column') {
          productGrid?.classList.remove('two-per-row');
        }
      });
    });
  }
}

customElements.define('collections-columns', CollectionsColumnsOnMobile);


// MEGA MENU

const menuItems = document.querySelectorAll('.header__link-with-menu');

menuItems.forEach(item => {
  item.addEventListener('mouseenter', () => {
    item.classList.add('open');
  });

  item.addEventListener('mouseleave', () => {
    item.classList.remove('open');
  });
});


class MegaMenu extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.mega-menu-new__parent-collections-btn');
    const subMenus = this.querySelectorAll('.mega-menu-new__nav');

    buttons.forEach(btn => {
      btn.addEventListener('mouseenter', (event) => {
        event.stopPropagation();
        let index = btn.getAttribute('data-index');
        let currentMenu = this.querySelector(`.mega-menu-new__nav[data-index="${index}"]`);

        buttons.forEach((button) => {
          button.classList.remove('active');
        });
        subMenus.forEach((menu) => {
          menu.classList.remove('active');
        });

        btn.classList.add('active');
        currentMenu?.classList.add('active');
      });
    });
  }
}

customElements.define('mega-menu', MegaMenu);

const mobileMegaMenuDropdownInputs = document.querySelectorAll('.mobile-mega-menu__parent-collection input[type="checkbox"]');

mobileMegaMenuDropdownInputs.forEach(input => {
  input.addEventListener('change', () => {
    mobileMegaMenuDropdownInputs.forEach(otherInput => {
      if (otherInput !== input) {
        otherInput.checked = false;
        const otherContent = otherInput.parentElement.querySelector('.mobile-mega-menu__parent-collection-items');
        otherContent.style.height = '0';
      }
    });

    const content = input.parentElement.querySelector('.mobile-mega-menu__parent-collection-items');
    if (input.checked) {
      content.style.height = content.scrollHeight + 'px';
    } else {
      content.style.height = '0';
    }
  });
});


class CollectionPopup extends HTMLElement {
  constructor() {
    super();

    this.closeBtn = this.querySelector('.collection-popup__close-btn');
    this.overlay = this.querySelector('.collection-popup__overlay');

    this.closeBtn.addEventListener('click', () => {
      this.closeWindow();
    });

    this.overlay.addEventListener('click', () => {
      this.closeWindow();
    });
  }

  closeWindow() {
    let iframeVideo = this.querySelector('iframe');

    if (iframeVideo) {
      let id = iframeVideo.id;

      // Створення плеєра
      let player = new YT.Player(id, {
        events: {
          'onReady': (event) => {
            event.target.pauseVideo(); // Виклик pauseVideo тільки коли плеєр готовий
          },
        },
      });
    }

    this.querySelector('.collection-popup__window').classList.remove('drawer-animation');

    setTimeout(() => {
      this.classList.remove('open');
    }, 300);
  }
}

customElements.define('collection-popup', CollectionPopup);


class FilterLink extends HTMLElement {
  constructor() {
    super();

    this.link = this.querySelector('a[href*="#popup-"]');

    this.link?.addEventListener('click', (e) => {
      e.preventDefault();
      const popupId = this.link.getAttribute('href');
      const targetPopup = document.getElementById(popupId);
      targetPopup.classList.add('open');
      setTimeout(() => {
        targetPopup.querySelector('.collection-popup__window').classList.add('drawer-animation');
      }, 1);
    });
  }

}

customElements.define('filter-link', FilterLink);


// COLLECTION VIDEO PLAY BTN

let collectionVideoPlayBtns = document.querySelectorAll('.custom-video-play-btn');

collectionVideoPlayBtns.forEach((btn) => {
  btn.addEventListener('click', () => {
    let video = btn.parentNode.querySelector('video');

    btn.style.display = 'none';
    video.play();
  });
});


// MOBILE OPTION SELECT
class MobileOptionSelect extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector('select');

    this.select?.addEventListener('change', (e) => {
      let value = this.select.value;
      let inputs = document.querySelectorAll('input');

      const currentInput = Array.from(inputs).find(input => input.value == value);

      currentInput?.click();
    });
  }

}

customElements.define('mobile-option', MobileOptionSelect);
